// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1PMtY","signatureButtonsRight":"ModalSign_signatureButtonsRight__2JdRK"};